export default {"src":"/_next/static/media/app-store_badge_ko.e889114d.svg","height":40,"width":130,"blurWidth":0,"blurHeight":0};